export const GET_PROVIDERS_LISTING = 'GET_PROVIDERS_LISTING'
export const GET_PROVIDERS_LISTING_PENDING = 'GET_PROVIDERS_LISTING_PENDING'
export const GET_PROVIDERS_LISTING_FULFILLED = 'GET_PROVIDERS_LISTING_FULFILLED'
export const GET_PROVIDERS_LISTING_REJECTED = 'GET_POLICY_MEMBERS_REJECTED'

export const GET_PROVIDER_DETAILS = 'GET_PROVIDER_DETAILS'
export const GET_PROVIDER_DETAILS_PENDING = 'GET_PROVIDER_DETAILS_PENDING'
export const GET_PROVIDER_DETAILS_FULFILLED = 'GET_PROVIDER_DETAILS_FULFILLED'
export const GET_PROVIDER_DETAILS_REJECTED = 'GET_POLICY_MEMBERS_REJECTED'
